import React, { useEffect, useState } from "react";

import { alpha, Grid, Skeleton, styled } from "@mui/material";
import { Box } from "@mui/system";
import { useRouter } from "../../../helper-functions/useRouterReplacement";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import useGetBanners from "../../../api-manage/hooks/react-query/useGetBanners";
import { getCurrentModuleType } from "../../../helper-functions/getCurrentModuleType";
import { getModuleId } from "../../../helper-functions/getModuleId";
import { ModuleTypes } from "../../../helper-functions/moduleTypes";
import { setBanners } from "../../../redux/slices/storedData";
import {
  CustomStackFullWidth,
  SliderCustom,
} from "../../../styled-components/CustomStyles.style";
import CustomImageContainer from "../../CustomImageContainer";
import FoodDetailModal from "../../food-details/foodDetail-modal/FoodDetailModal";

export const BannersWrapper = styled(Box)(({ theme }) => ({
  cursor: "pointer",
  borderRadius: "12px",
  width: "100%",
  height: "230px",
  position: "relative",
  overflow: "hidden",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.palette.mode === 'dark'
    ? `0px 4px 12px ${alpha(theme.palette.common.black, 0.2)}`
    : "0px 4px 12px rgba(0, 0, 0, 0.08)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: theme.palette.mode === 'dark'
      ? `0px 8px 24px ${alpha(theme.palette.common.black, 0.4)}`
      : "0px 8px 24px rgba(0, 0, 0, 0.12)",
    img: {
      transform: "scale(1.05)",
      transition: "transform 0.3s ease-in-out",
    },
  },

  [theme.breakpoints.down("md")]: {
    height: "200px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "150px",
  },
}));
const Banners = (props) => {
  const router = useRouter();
  const { selectedModule } = useSelector((state) => state.utilsData);
  const { banners } = useSelector((state) => state.storedData);
  const { data, refetch: refetchBannerData, isFetching } = useGetBanners();
  const [bannersData, setBannersData] = useState([]);
  const [foodBanner, setFoodBanner] = useState();
  const [openModal, setOpenModal] = useState(false);
  const { configData } = useSelector((state) => state.configData);
  const dispatch = useDispatch();
  useEffect(() => {
    if (banners.banners.length === 0) {
      refetchBannerData();
    }
  }, [banners]);
  useEffect(() => {
    if (data) {
      dispatch(setBanners(data));
    }
  }, [data]);
  useEffect(() => {
    if (banners) {
      handleBannersData();
    }
  }, [banners]);

  const handleBannersData = () => {
    let mergedBannerData = [];

    if (getCurrentModuleType() === "food") {
      if (banners?.banners?.length > 0) {
        banners?.banners?.forEach((item) => mergedBannerData.push(item));
      }
      if (banners?.campaigns?.length > 0) {
        banners?.campaigns?.forEach((item) =>
          mergedBannerData.push({ ...item, isCampaign: true })
        );
      }
      setBannersData(mergedBannerData);
    } else {
      if (banners?.banners?.length > 0) {
        banners?.banners?.forEach((item) => mergedBannerData.push({ ...item }));
      }
      setBannersData(mergedBannerData);
    }
  };
  const handleBannerClick = (banner) => {
    if (banner?.isCampaign) {
      router.push(
        {
          pathname: "/campaigns/[id]",
          query: { id: `${banner?.id}`, module_id: `${getModuleId()}` },
        },
        undefined,
        { shallow: true }
      );
    } else {
      if (banner?.type === "store_wise") {
        const storeId = banner?.store?.slug ? banner?.store?.slug : banner?.store?.id;
        const storeType = getCurrentModuleType() === 'food' ? 'restaurant' : 'supermarket';
        const queryParams = new URLSearchParams({
          id: banner?.store?.id,
          [storeType]: banner?.store?.id,
          module_id: banner?.store?.module_id,
          store_zone_id: banner?.store?.zone_id,
        });
        router.push(`/store/${storeType}?${queryParams.toString()}`);
      } else {
        if (banner?.type === "item_wise") {
          if (selectedModule?.module_type !== "ecommerce") {
            setFoodBanner(banner?.item);
            setOpenModal(true);
          } else {
            router.push(
              {
                pathname: "/product/[id]",
                query: {
                  id: `${
                    banner?.item?.slug ? banner?.item?.slug : banner?.item?.id
                  }`,
                  module_id: `${getModuleId()}`,
                },
              },
              undefined,
              { shallow: true }
            );
          }
        }
      }
    }
  };
  const handleModalClose = () => {
    setOpenModal(false);
    //setBannerData(null);
  };

  const getModuleWiseBanners = () => {
    switch (getCurrentModuleType()) {
      case ModuleTypes.GROCERY:
        if (bannersData.length > 1) {
          return 2;
        } else {
          return 2;
        }
      case ModuleTypes.PHARMACY:
        if (bannersData.length === 1) {
          return 1;
        } else if (bannersData.length === 2) {
          return 2;
        } else {
          return 3;
        }
      case ModuleTypes.ECOMMERCE:
        if (bannersData.length > 1) {
          return 2;
        } else {
          return 1;
        }
      case ModuleTypes.FOOD:
        if (bannersData.length === 1) {
          return 1;
        } else if (bannersData.length === 2) {
          return 2;
        } else {
          return 3;
        }
    }
  };

  const settings = {
    dots: false,
    infinite: bannersData.length > 2 && true,
    slidesToShow: getModuleWiseBanners(),
    slidesToScroll: 1,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 4000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <CustomStackFullWidth
        sx={{
          mt: "30px",
          "& .slick-list": {
            marginRight: { xs: "-10px", sm: "-20px" },
          },
          "& .slick-slide": {
            paddingRight: { xs: "10px", sm: "20px" },
          },
        }}
      >
        {isFetching ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Slider {...settings}>
                {[...Array(getModuleWiseBanners())].map((item, index) => {
                  return (
                    <BannersWrapper key={`banner-skeleton-${index}`}>
                      <Skeleton
                        variant="rectangle"
                        // width="100%"
                        height="100%"
                      />
                    </BannersWrapper>
                  );
                })}
              </Slider>
            </Grid>
          </Grid>
        ) : (
          <SliderCustom>
            <Slider {...settings}>
              {bannersData?.length > 0 &&
                bannersData?.map((item, index) => {
                  return (
                    <BannersWrapper
                      key={item?.id || `banner-${index}`}
                      onClick={() => handleBannerClick(item)}
                    >
                      <CustomImageContainer
                        src={`${
                          item?.isCampaign
                            ? configData?.base_urls?.campaign_image_url
                            : configData?.base_urls?.banner_image_url
                        }/${item?.image}`}
                        alt={item?.title}
                        height="100%"
                        width="100%"
                        objectfit="cover"
                        borderRadius="10px"
                      />
                    </BannersWrapper>
                  );
                })}
            </Slider>
          </SliderCustom>
        )}
      </CustomStackFullWidth>
      {openModal && foodBanner && (
        <FoodDetailModal
          product={foodBanner}
          image={`${configData?.base_urls?.item_image_url}/${foodBanner?.image}`}
          open={openModal}
          handleModalClose={handleModalClose}
          setOpen={setOpenModal}
        />
      )}
    </>
  );
};

Banners.propTypes = {};

export default Banners;
